import React, {useContext} from 'react'

import {HouseContext} from "./HouseContext";

import House from "./House";

import {Link} from "react-router-dom";

import {ImSpinner2} from "react-icons/im";

const HouseList = () => {
    const {houses, loading} = useContext(HouseContext);
    // console.log(houses);

    if(loading) {
        return (
            <ImSpinner2 className='mx-auto  animate-spin text-4xl text-teal-600 font-bold mt-[200px] '/>
        )
    }

    if(houses.length < 1) {
        return <div className="container mx-auto px-4 py-20 text-center text-slate-600">Sorry, no match found!</div>
    }

    return (
        <section className='relative z-10 -mt-4 mb-20 py-12 md:py-16'>
            <div className="container mx-auto max-w-[1120px] px-4">
                <div className="mb-8 flex flex-col justify-between gap-4 md:flex-row md:items-end">
                    <div>
                        <p className="text-sm font-bold uppercase tracking-[0.22em] text-teal-700">Featured availability</p>
                        <h2 className="mt-2 text-3xl font-bold tracking-tight text-slate-950 md:text-4xl">Lavallette rentals</h2>
                    </div>
                    <p className="max-w-xl text-slate-600">
                        Curated weekly stays with clear availability, direct booking details, and the essentials visible at a glance.
                    </p>
                </div>
                <div className='grid md:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-6'>
                    {houses.map((house,index) => {
                        return(
                            <Link to={`/property/${house.id}`} key={index} className="group block animate-fade-up">
                                <House house={house}/>
                            </Link>
                        )
                    })}
                </div>
            </div>

        </section>
    )
}

export default HouseList;
